
import React from 'react';
import { Button } from '@/components/ui/button';
import { Assessment } from '@/types/assessment';
import { FileCheck, Save, Loader2 } from 'lucide-react';

interface SaveActionsProps {
  assessment?: Assessment | null;
  loading: boolean;
  hasUnsavedChanges?: boolean;
  onSave: () => void;
  onPublish?: () => void;
  showPublish?: boolean;
}

export function SaveActions({ 
  assessment, 
  loading, 
  hasUnsavedChanges = false,
  onSave, 
  onPublish,
  showPublish = true
}: SaveActionsProps) {
  return (
    <div className="flex items-center gap-3">
      {hasUnsavedChanges && (
        <span className="text-sm text-muted-foreground flex items-center gap-1">
          <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse" />
          Unsaved changes
        </span>
      )}
      
      <div className="flex gap-2">
        <Button 
          onClick={onSave}
          disabled={loading}
          variant={hasUnsavedChanges ? "default" : "outline"}
          size="sm"
        >
          {loading ? (
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
          ) : (
            <Save className="h-4 w-4 mr-2" />
          )}
          {assessment?.status === 'published' ? 'Update' : 'Save Draft'}
        </Button>

        {showPublish && assessment?.status === 'draft' && onPublish && (
          <Button 
            onClick={onPublish}
            disabled={loading} 
            className="bg-green-600 hover:bg-green-700"
            size="sm"
          >
            <FileCheck className="h-4 w-4 mr-2" />
            Publish
          </Button>
        )}
      </div>
    </div>
  );
}
